import { esc, badge } from '/core/js/utils.js';

/**
 * One card on Settings, for the platform's cards (settings.js) and each
 * module's (its `settings` component), so they all read alike:
 *
 *   card(title, test, purpose, rows, extra, actions)
 *                                             rows: [[label, html], …]; test: a
 *                                             name for the Test button, or null;
 *                                             actions: more header buttons (html)
 *   failedCard(title, err)                    when its data could not be loaded
 *   setBadge(isSet)                           a secret shown only as set / not set
 *   runTest(root, btn, fn)                    runs fn() for a Test button and shows
 *                                             { ok, message } under its card
 */
export function card(title, test, purpose, rows, extra = '', actions = '') {
  return `
    <div class="card" data-card="${esc(test ?? '')}">
      <div class="card-header"><span>${esc(title)}</span>
        <span class="page-header-actions">${actions}${test ? `<button type="button" class="btn btn-sm btn-secondary" data-test="${esc(test)}">Test</button>` : ''}</span></div>
      <div class="card-body">
        <p class="text-muted">${purpose}</p>
        ${extra}
        <dl class="kv">${rows.map(([k, v]) => `<dt>${esc(k)}</dt><dd>${v}</dd>`).join('')}</dl>
        ${test ? '<p class="card-block" data-result hidden></p>' : ''}
      </div>
    </div>`;
}

export function failedCard(title, err) {
  return `<div class="card"><div class="card-header"><span>${esc(title)}</span></div>
    <div class="card-body"><div class="alert alert-danger">${esc(err?.message ?? 'Could not load this')}</div></div></div>`;
}

export const setBadge = (isSet) => badge(isSet ? 'active' : 'none', isSet ? 'set' : 'not set');

export async function runTest(root, btn, fn) {
  const out = root.querySelector(`[data-card="${btn.dataset.test}"] [data-result]`);
  btn.disabled = true;
  btn.textContent = 'Testing…';
  out.hidden = true;
  let res;
  try {
    res = await fn();
  } catch (err) {
    res = { ok: false, message: err.message ?? 'The test could not be run' };
  } finally {
    btn.disabled = false;
    btn.textContent = 'Test';
  }
  out.innerHTML = `${badge(res.ok ? 'ok' : 'failed', res.ok ? 'works' : 'failed')} ${esc(res.message)}`;
  out.hidden = false;
}
